import { render, staticRenderFns } from "./tab-cell-name.vue?vue&type=template&id=04e816b9&scoped=true"
import script from "./tab-cell-name.vue?vue&type=script&lang=js"
export * from "./tab-cell-name.vue?vue&type=script&lang=js"
import style0 from "./tab-cell-name.vue?vue&type=style&index=0&id=04e816b9&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e816b9",
  null
  
)

export default component.exports